<script>
    import BaseComponent from "Components/offers/Index";
    export default {
        extends: BaseComponent,
        props: {
            equipmentId: {
                type: [Number, String],
                required: true
            }
        },
        methods: {
            async initialize () {
                var query = this.$db.Offer
                    .where('equipment_id', this.equipmentId)
                    .orderBy(this.orderBy)
                    .append('document_number', 'full_proforma_number', 'invoice_number', 'invoice_date')
                    .include('customer', 'equipment', 'invoice')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                if(!this._.isNil(this.filterByUser)) query = query.where('created_by', this.filterByUser.join(','))
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            }
        }
    };
</script>
